import { useSplitEnabled } from '@buffer-mono/features'
import type { Draft } from '../../../entities/Draft'
import ThreadsLocationComposerBar from '~publish/legacy/composer/composer/components/threads-location/ThreadsLocationComposerBar'
import ThreadsTopicField from '~publish/legacy/composer/composer/components/threads-topic/ThreadsTopicField'
import { Wrapper } from '../styles'

export const ThreadsChannelFields = ({
  draft,
}: {
  draft: Draft
}): JSX.Element => {
  const { isEnabled: isThreadsLocationTaggingEnabled } =
    useSplitEnabled('threads-location')

  if (!draft.service.isThreads() || !isThreadsLocationTaggingEnabled) {
    return <></>
  }

  return (
    <Wrapper>
      <ThreadsTopicField draft={draft} />
      <ThreadsLocationComposerBar draft={draft} />
    </Wrapper>
  )
}
